import axios from '@axios'

export default {
  namespaced: true,
  state: {
    user: {},
    serviceProvider: {},
    userManaged: {},
    geoData:{
      address: {},
      lat: '',
      lon: '',
      confirmed: false,
    },
  },
  getters: {
    user: state => state.user,
    serviceProvider: state => state.serviceProvider,
    userManaged: state => state.userManaged,
    geoData: state => state.geoData,
  },
  mutations: {

    setUser(state, user) {
      state.user = user
    },
    setServiceProvider(state, user) {
      state.serviceProvider = user
    },
    setUserManaged(state, user) {
      state.userManaged = user
    },
    unsetUserManaged(state){
      state.userManaged = {}
    },
    updateUser(state, user) {
      state.user = { ...state.user, ...user }
    },
    setGeoData(state, geoData){
      state.geoData = {...state.geoData, ...geoData}
    },
    setGeoDataConfirmed(state, confirmed){
      state.geoData.confirmed = confirmed
    },
    setGeoDataLat(state, lat){
      state.geoData.lat = lat
    },
    setGeoDataLon(state, lon){
      state.geoData.lon = lon
    },
    updateGeoData(state, geoData){
      state.geoData =  {...state.geoData, ...geoData}
    }
  },
  actions: {
    setUserManaged(ctx, user) {
      ctx.commit('setUserManaged', user)
    },
    async fetchServiceProviderPublic(ctx, { id }) {
      const response = await axios.get(`/public/service-providers/${id}?include=manager.languages,service_offers.point_type,service_offers.point_purposes,service_offers.media_files,service_offers.address,service_offers.business_hours,languages`)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setServiceProvider', response.data.data)
      }
      return response
    },
    async fetchServiceProvider(ctx, { id }) {
      const response = await axios.get(`/service-providers/${id}?include=manager,service_offers.business_hours,service_offers.point_type,service_offers.point_purposes,service_offers.media_files,service_offers.address,languages`)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        ctx.commit('setServiceProvider', response.data.data)
      }
      return response
    },

    async fetchServiceProviders(ctx, queryParams) {
      const response = await axios.get('/service-providers?include=manager,languages,service_offers.point_type,service_offers.point_purposes,service_offers.media_files,service_offers.address', {
        params: queryParams,
      }).catch(error => console.log(error))
      return response
    },

    async fetchServiceProviderPhones(ctx, { id }) {
      return await axios.get(`/service-providers/${id}/phones`)
    },
    
    async fetchServiceProviderContacts(ctx, { id }) {
      return await axios.get(`/service-providers/${id}/contacts`)
    },

    async fetchServiceProviderPhonesPublic(ctx, { id }) {
      return await axios.get(`/public/service-providers/${id}/phones`)
    },

    async fetchServiceProviderContactsPublic(ctx, { id }) {
      return await axios.get(`/public/service-providers/${id}/contacts`)
    },

    async fetchUserPhones(ctx, { id }) {
      return await axios.get(`/users/${id}/phones`)
    },

    async fetchUserContacts(ctx, { id }) {
      return await axios.get(`/users/${id}/contacts`)
    },

    async fetchReferralPhones(ctx, { id }) {
      return await axios.get(`/referrals/${id}/phones`)
    },

    async fetchReferralContacts(ctx, { id }) {
      return await axios.get(`/referrals/${id}/contacts`)
    },

    async createUserManaged(ctx, account) {
      const response = await axios.post('users/managed', account)
      const successStatuses = [200, 201]
      if (successStatuses.includes(response.status)) {
        response.statusText = 'added'
      } else {
        response.statusText = 'error'
      }
      return response
    },
    async fetchGeoData(ctx) {
      try {
        const response = await axios.get('/ip-locator');
        const { status, data: responseData } = response;

        // 1. Success check
        if (status >= 200 && status < 300) {

          // The external API response structure is nested like: { data: { country_code: "US", ... } }
          const geoDataPayload = responseData?.data;

          // 2. Check for missing nested 'data' property
          if (!geoDataPayload) {
            console.warn('fetchGeoData: Success status (2xx), but missing expected "data" payload in response body.');
            return null;
          }

          // 3. **NEW: Check for the "null-filled" payload**
          // Check if the mandatory fields (e.g., country_code) are null.
          // Assuming 'country_code' is a reliable indicator of successful geo-lookup.
          if (geoDataPayload.country_code === null) {
            console.info('fetchGeoData: Successfully received response, but geo-data is null (likely IP not found).', geoDataPayload);
            // Optionally, commit a default/empty state if required by your application
            // ctx.commit('setGeoData', { country_code: null, currency: null, lat: null, lon: null });
            return null; // Signal that no valid geo data was obtained
          }

          // 4. Process and Commit Data
          // Use destructuring and the rest operator to create a clean object without 'status'
          const { status: _, ...geoData } = geoDataPayload;

          ctx.commit('setGeoData', geoData);
          return geoData; // Return the processed data on success
        }

        // Handle non-2xx status codes that didn't throw an error
        console.error(`fetchGeoData: Received non-success HTTP status code: ${status}`, response.data);
        return response;

      } catch (error) {
        // Axios errors (4xx, 5xx) typically land here.
        if (axios.isAxiosError(error)) {
          const status = error.response?.status;
          const errorData = error.response?.data;
          console.error(`fetchGeoData: Axios Error: HTTP Status ${status}`, errorData);
          return { error: true, status, data: errorData };
        }

        // Log other errors (e.g., network issues) and re-throw
        console.error('fetchGeoData: An unexpected error occurred:', error.message, error);
        throw error;
      }
    }

  },
}
